import {FC, MouseEvent, useState} from 'react';
import {useRecoilValue} from 'recoil';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Table, TableBody, TableHead} from '@mui/material';

import {IContactPerson} from '../../../../../../shared/types/person.types';

import {partyRelOfContactPersonSelectorFamily} from '../../../../../../store/contact-person/selectors';

import {colors} from '../../../../../../shared/colors';

interface IContactPersonOfCompanyRow {
  row: IContactPerson;
  handleEditClick: (e: MouseEvent<HTMLButtonElement>) => void;
  handleDeleteClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const ContactPersonOfCompanyRow: FC<IContactPersonOfCompanyRow> = ({
  row,
  handleEditClick,
  handleDeleteClick,
}) => {
  const partyRel = useRecoilValue(partyRelOfContactPersonSelectorFamily(row.id));
  const [open, setOpen] = useState(false);

  const toggleCollapse = (e: MouseEvent<HTMLTableRowElement | HTMLButtonElement>) => {
    e.stopPropagation();

    setOpen(!open);
  };

  return (
    <>
      <TableRow sx={{cursor: 'pointer'}} hover onClick={toggleCollapse} selected={open}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={toggleCollapse}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{`${row.lastName} ${row.firstName} ${row.patronymic || ''}`}</TableCell>
        <TableCell align="left">
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            href={`tel:${row.phoneNumber}`}
          >
            {row.phoneNumber}
          </a>
        </TableCell>
        <TableCell align="left">
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            href={`mailto:${row.email}`}
          >
            {row.email}
          </a>
        </TableCell>
        <TableCell align="left">{row.birthDate}</TableCell>
        <TableCell align="left">
          <Tooltip title="Изменить">
            <IconButton onClick={handleEditClick}>
              <ModeEditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Удалить">
            <IconButton onClick={handleDeleteClick}>
              <DeleteForeverIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <TableRow sx={{backgroundColor: colors['bg--on-white']}}>
        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontWeight: 'bold'}} align="center">
                    Должность
                  </TableCell>
                  <TableCell sx={{fontWeight: 'bold'}} align="center">
                    Зона ответственности
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{partyRel?.relationTitle}</TableCell>
                  <TableCell>{partyRel?.description}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
